import React from 'react';

import Grid from '@material-ui/core/Grid';

import HomeCard from '../components/HomeCard'
import books from '../assets/images/books.png'
import cloud from '../assets/images/cloud.png'

function Home(props) {

    const callSearchView = () => {
        props.history.push({pathname: `/search/`})
    }

    const callSearchRepositoriesView = () => {
        props.history.push({pathname: '/search-repositories'})
    }

    return (
        <Grid>
            <Grid container justify="center">
                <Grid item xs md={6} lg={4}>
                    <HomeCard
                        title="SIGAA"
                        subtitle="Busque em todo o acervo de bibliotecas da UFRN"
                        image={books}
                        onClick={() => callSearchView()}
                    />
                </Grid>
            </Grid>            
            <Grid container justify="center">
                <Grid item xs md={6} lg={4}>
                    <HomeCard 
                        title="Repositórios"
                        subtitle="Consulte nas bases digitais da UFRN"
                        image={cloud}
                        onClick={() => callSearchRepositoriesView()}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}
  
export default Home;